import EntityType from "@mapmycustomers/shared/enum/EntityType";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import checkIfConditionCanBeUsedInWebApp from "@app/util/filters/checkIfConditionCanBeUsedInWebApp";

export const MAP_FILTER_KEYS = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
  "universal",
] as const;

const isMapFilterWebCompatible = (filter: MapFilterModel): boolean =>
  MAP_FILTER_KEYS.every((key) => {
    const condition = filter[key];

    if (!condition) {
      return true;
    }

    return checkIfConditionCanBeUsedInWebApp(getFieldModelByEntityType(key), condition);
  });

export default isMapFilterWebCompatible;
